import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-weight-medium" }, "Id: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_resource_link = _resolveComponent("resource-link")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resource, index) => {
        return (_openBlock(), _createBlock(_component_q_item, {
          key: index,
          class: "no-padding"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "q-pb-sm" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, { class: "text-weight-medium" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(resource.type), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_resource_link, { resource: resource }, null, 8, ["resource"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}